import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import moment from 'moment';

import { uniqBy, isEqual } from 'lodash';

import { getFormValues, reset, change } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Typography from '@material-ui/core/Typography';
import Button from 'components/common/Button';
import Link from 'components/common/Link';
import Tooltip from 'components/common/Tooltip';
import IconGear from 'components/icons/IconGear';
import IconList from 'components/icons/IconList';
import IconHistory from 'components/icons/IconHistory';
import IconRefresh from 'components/icons/IconRefresh';
import IconStar from 'components/icons/IconStar';
import IconStarOutline from 'components/icons/IconStarOutline';

import { Scrollbars } from 'react-custom-scrollbars';

import Progress from 'components/common/Progress';

import NotificationsSettingsDialog from 'components/home/NotificationsSettingsDialog';

import dateFormat from 'config/dateFormat';
import timeDateFormat from 'config/timeDateFormat';
import * as validate from 'utils/validate';

import {
  initializeUserNotifications,
  fetchUserNotifications,
  readUserNotifications,
  readAllUserNotifications,
} from 'redux/modules/userNotifications';
import { fetchBusiness } from 'redux/modules/business';
import { updateUser } from 'redux/modules/users';

import NotificationsFilterForm from './NotificationsFilterForm';
import NotificationsItem from './NotificationsItem';
import NotificationsHistoryDialog from './NotificationsHistoryDialog';

const styles = theme => ({
  root: {
    overflow: 'hidden',
    position: 'relative',
    minHeight: '100%',
    boxSizing: 'border-box',
    padding: '46px 0 0 16px',
    marginBottom: 12,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 78,
      paddingLeft: 4,
    },
  },
  rootEmpty: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  form: {
    position: 'absolute',
    top: 16,
    left: 98,
    right: 124,
    zIndex: 10,
    [theme.breakpoints.down('xs')]: {
      left: 46,
      right: 46,
      top: 8,
    },
  },
  formControls: {
    position: 'absolute',
    zIndex: 5,
    top: 8,
    left: 12,
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
      left: 8,
      top: 0,
    },
  },
  controls: {
    display: 'flex',
    position: 'absolute',
    zIndex: 5,
    top: 8,
    right: 8,
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column-reverse',
      top: 0,
      right: 8,
    },
  },
  iconHistory: {
    width: 23,
    height: 23,
  },
  iconGear: {
    width: 16,
    height: 16,
  },
  iconRefresh: {
    width: 16,
    height: 16,
  },
  iconStar: {
    width: 20,
    height: 20,
  },
  iconStarOutline: {
    width: 20,
    height: 20,
  },
  button: {
    width: 30,
    height: 30,
    minHeight: 30,
    margin: '8px 4px',
    color: theme.palette.grey[600],
    [theme.breakpoints.down('xs')]: {
      margin: '8px 0 0 0',
    },
  },
  table: {
    marginTop: 8,
    marginRight: 16,
    width: 'calc(100% - 16px)',
    [theme.breakpoints.down('xs')]: {
      marginRight: 8,
      width: 'calc(100% - 8px)',
    },
  },
  count: {
    position: 'absolute',
    backgroundColor: theme.palette.common.white,
    right: 16,
    bottom: 4,
  },
  link: {
    paddingTop: 8,
    paddingBottom: 4,
    marginBottom: -4,
  },
});

class Notifications extends Component {
  constructor(props) {
    super(props);

    this.state = {
      limit: 50,
      offset: 0,
      triggerLoading: true,
      notificationsSettingsDialogOpen: false,
      notificationsHistoryDialogOpen: false,
    };

    this.onRequest = this.onRequest.bind(this);
    this.onUserNotificationsScrollFetchRequest = this.onUserNotificationsScrollFetchRequest.bind(this);
    this.onNotificationsSettingsButtonClick = this.onNotificationsSettingsButtonClick.bind(this);
    this.onNotificationsSettingsDialogClose = this.onNotificationsSettingsDialogClose.bind(this);
    this.onNotificationsSettingsSubmitSuccess = this.onNotificationsSettingsSubmitSuccess.bind(this);
    this.onNotificationsHistoryButtonClick = this.onNotificationsHistoryButtonClick.bind(this);
    this.onNotificationsHistoryDialogClose = this.onNotificationsHistoryDialogClose.bind(this);
    this.onReadAllButtonClick = this.onReadAllButtonClick.bind(this);
  }

  componentWillMount() {
    const {savedFilters, actions } = this.props;
    const savedFilterValues = savedFilters ? savedFilters['notificationsFilter'] : null;
    if (savedFilterValues) {
      reset();
      Object.keys(savedFilterValues).forEach((filterName) => {
        actions.change('notificationsFilter', filterName, savedFilterValues[filterName]);
      });
    }
  }

  componentDidMount() {
    const { actions, initialized } = this.props;
    if (!initialized) {
      actions.initializeUserNotifications();
    } else {
      this.onRequest();
    }
    actions.fetchBusiness({
      triggerLoading: false,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { initialized, loading, filters } = this.props;
    const { limit, offset } = this.state;
    const filtersChanged =
      filters['Notification Type'] !== nextProps.filters['Notification Type']
      || filters['Date From'] !== nextProps.filters['Date From']
      || filters['Date To'] !== nextProps.filters['Date To']
      || filters['User ID'] !== nextProps.filters['User ID']
      || filters['Watcher User ID'] !== nextProps.filters['Watcher User ID']
      || filters['Patient ID'] !== nextProps.filters['Patient ID'];
    const newState = {};
    if (filtersChanged) {
      newState.offset = 0;
    } else if (initialized
      && loading === 0
      && this.scrollbarsRef
      && this.scrollbarsRef.getScrollHeight() <= this.scrollbarsRef.getClientHeight()
      && (nextProps.userNotifications.length - limit) >= offset) {
      newState.offset = offset + limit;
    }
    this.setState(newState);
  }

  componentDidUpdate(prevProps, prevState) {
    const { initialized, filters } = this.props;
    const { limit, offset } = this.state;
    const filtersChanged =
      filters['Notification Type'] !== prevProps.filters['Notification Type']
      || filters['Date From'] !== prevProps.filters['Date From']
      || filters['Date To'] !== prevProps.filters['Date To']
      || filters['User ID'] !== prevProps.filters['User ID']
      || filters['Watcher User ID'] !== prevProps.filters['Watcher User ID']
      || filters['Patient ID'] !== prevProps.filters['Patient ID'];
    const limitChanged = prevState.limit !== limit;
    const offsetChanged = prevState.offset !== offset;
    if (initialized && (!prevProps.initialized || filtersChanged || limitChanged || offsetChanged)) {
      this.onRequest();
    }
  }

  onRequest() {
    const { actions, userNotifications, account, filters } = this.props;
    const { limit, offset, triggerLoading,  } = this.state;
    const requestFilters = filters && Object.keys(filters).length > 0
      ? Object.keys(filters).map((key) => {
        let name = key;
        let val = filters[key];
        switch (key) {
          case 'User ID':
            name = 'Assigned User ID';
            break;
          case 'Watcher User ID':
            name = 'Watcher ID';
            break;
          case 'Notification Type':
            val = [filters[key]];
            break;
          default:
        }
        return {
          name,
          val,
        };
      })
      : [];
    actions.fetchUserNotifications({
      limit,
      offset,
      triggerLoading: offset === 0,
      filters: requestFilters,
      push: offset > 0,
    });
  }

  onUserNotificationsScrollFetchRequest() {
    const { offset, limit } = this.state;
    if ((this.props.userNotifications.length - limit) >= offset) {
      this.setState({ offset: offset + limit });
    }
  }

  onNotificationsSettingsButtonClick() {
    this.setState({ notificationsSettingsDialogOpen: true });
  }

  onNotificationsSettingsDialogClose() {
    this.setState({ notificationsSettingsDialogOpen: false });
  }

  onNotificationsSettingsSubmitSuccess() {
    const { offset } = this.state;
    this.onNotificationsSettingsDialogClose();
    if (offset !== 0) {
      this.setState({
        offset: 0,
        triggerLoading: true,
      });
    } else {
      this.setState({
        triggerLoading: true,
      });
      this.onRequest();
    }
  }

  onNotificationsHistoryButtonClick() {
    this.setState({ notificationsHistoryDialogOpen: true });
  }

  onNotificationsHistoryDialogClose() {
    this.setState({ notificationsHistoryDialogOpen: false });
  }

  onReadAllButtonClick() {
    const { actions, filters } = this.props;
    actions.readAllUserNotifications({
      filters: filters && Object.keys(filters).length > 0
      ? Object.keys(filters).map((key) => {
        let name = key;
        let val = filters[key];
        switch (key) {
          case 'User ID':
            name = 'Assigned User ID';
            break;
          case 'Watcher User ID':
            name = 'Watcher ID';
            break;
          case 'Notification Type':
            val = [filters[key]];
            break;
          default:
        }
        return {
          name,
          val,
        };
      })
      : [],
    });
  }

  render() {
    const { userNotifications, business, loading, initialized, actions,
      account, savedFilters, filters, filterFormValues, count, filterCount, expanded, classes, width } = this.props;
    const { notificationsSettingsDialogOpen, notificationsHistoryDialogOpen, offset} = this.state;
    const savedFilterValues = savedFilters ? savedFilters['notificationsFilter'] : {};
    const compareFilterValues = Object.assign({}, filterFormValues);
    const compareSavedFilterValues = Object.assign({}, savedFilterValues);
    delete compareFilterValues['User Name'];
    delete compareFilterValues['Selected User Name'];
    delete compareFilterValues['Notification Type'];
    delete compareFilterValues['Selected Notification Type'];
    delete compareSavedFilterValues['User Name'];
    delete compareSavedFilterValues['Selected User Name'];
    delete compareSavedFilterValues['Notification Type'];
    delete compareSavedFilterValues['Selected Notification Type'];
    const savedFiltersActive = savedFilters ? isEqual(compareSavedFilterValues, compareFilterValues) : false;
    let collapsedHeight = 184;
    if (width === 'xs') {
      collapsedHeight = 250;
    } else if (width === 'sm') {
      collapsedHeight = 282;
    }
    return (
      <Paper
        className={classNames(classes.root, {
          [classes.rootEmpty]: userNotifications.length === 0,
        })}
      >
        <div className={classes.formControls}>
          <Tooltip
            content="Clear All Filters"
            placement="top"
            color="dark"
            disableGutters
          >
            <Button
              variant="fab"
              className={classes.button}
              onClick={() => {
                actions.reset('notificationsFilter');
              }}
            >
              <IconRefresh className={classes.iconRefresh} />
            </Button>
          </Tooltip>
          <Tooltip
            content={savedFiltersActive
              ? 'Clear Saved Filters' : 'Save Filters'}
            placement="top"
            color="dark"
            disableGutters
          >
            <Button
              variant="fab"
              className={classes.button}
              onClick={() => {
                if (savedFiltersActive) {
                  const newSavedFilters = Object.assign({}, savedFilters);
                  delete newSavedFilters['notificationsFilter'];
                  actions.updateUser({
                    values: {
                      ID: account.ID,
                      'Saved Filters': Object.keys(newSavedFilters).length !== 0 ? JSON.stringify(newSavedFilters) : null,
                    },
                  });
                } else {
                  actions.updateUser({
                    values: {
                      ID: account.ID,
                      'Saved Filters': JSON.stringify({
                        ...savedFilters,
                        ...{ 'notificationsFilter': filterFormValues },
                      }),
                    },
                  });
                }
              }}
            >
              {savedFiltersActive
                ? <IconStar className={classes.iconStar} />
                : <IconStarOutline className={classes.iconStarOutline} />
              }
            </Button>
          </Tooltip>
        </div>
        <NotificationsFilterForm
          className={classes.form}
          form="notificationsFilter"
          account={account}
        />
        <div className={classes.controls}>
          <Tooltip
            content="History"
            placement="top"
            color="dark"
            disableGutters
          >
            <Button
              variant="fab"
              className={classes.button}
              onClick={this.onNotificationsHistoryButtonClick}
            >
              <IconHistory className={classes.iconHistory} />
            </Button>
          </Tooltip>
          <Tooltip
            content="Settings"
            placement="top"
            color="dark"
            disableGutters
          >
            <Button
              variant="fab"
              className={classes.button}
              onClick={this.onNotificationsSettingsButtonClick}
            >
              <IconGear className={classes.iconGear} />
            </Button>
          </Tooltip>
          <NotificationsHistoryDialog
            open={notificationsHistoryDialogOpen}
            onClose={this.onNotificationsHistoryDialogClose}
          />
          <NotificationsSettingsDialog
            open={notificationsSettingsDialogOpen}
            onClose={this.onNotificationsSettingsDialogClose}
            onSubmitSuccess={this.onNotificationsSettingsSubmitSuccess}
          />
        </div>
        {(!initialized || loading > 0) ? (
          <Progress />
        ) : (
          <Fragment>
            {userNotifications.length > 0 ? (
              <Fragment>
                <Scrollbars
                  autoHeight
                  autoHeightMin={expanded ? 584 : collapsedHeight}
                  autoHeightMax={expanded ? 584 : collapsedHeight}
                  thumbMinSize={30}
                  universal
                  onScrollFrame={(event) => {
                    if (event.top > 0.8) {
                      this.onUserNotificationsScrollFetchRequest();
                    }
                  }}
                  ref={scrollbarsRef => {
                    this.scrollbarsRef = scrollbarsRef;
                  }}
                >
                  <Table className={classes.table}>
                    <TableBody>
                      {userNotifications.map(item => (
                        <NotificationsItem
                          key={item.ID}
                          business={business}
                          {...item}
                          onClick={() => {
                            if (!item['Has Read']) {
                              actions.readUserNotifications({ ID: [item.ID] });
                            }
                          }}
                          onPatientItemClick={(patientItem) => {
                            if (!patientItem['Has Read']) {
                              actions.readUserNotifications({ ID: [patientItem.ID] });
                            }
                          }}
                          onPatientNotificationsLoad={(values) => {
                            actions.fetchUserNotifications({
                              filters: [{
                                name: 'Patient ID',
                                val: values['Patient ID'],
                              }],
                              patientNotifications: true,
                            });
                          }}
                        />
                      ))}
                    </TableBody>
                  </Table>
                </Scrollbars>
                <Typography className={classes.count} variant="caption" align="center">
                  {filterCount > 0 ? (
                    <Tooltip
                      content="Mark loaded Notifications as read"
                      placement="top"
                      color="dark"
                      disableGutters
                    >
                      <Link
                        className={classes.link}
                        color="primary"
                        underline
                        bold
                        size="sm"
                        onClick={this.onReadAllButtonClick}
                      >
                        Unread {filterCount}
                      </Link>
                    </Tooltip>
                  ) : 'Unread 0'}
                  {count !== filterCount ? ` / ${count}` : ''}
                </Typography>
              </Fragment>
            ) : (
              <Typography variant="caption" align="center">
                No new notifications
              </Typography>
            )}
          </Fragment>        
        )}
      </Paper>
    );
  }
}

Notifications.propTypes = {
  userNotifications: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  loading: PropTypes.number.isRequired,
  initialized: PropTypes.bool.isRequired,
  count: PropTypes.number,
  filterCount: PropTypes.number,
  expanded: PropTypes.bool,
  actions: PropTypes.shape({
    initializeUserNotifications: PropTypes.func.isRequired,
    fetchUserNotifications: PropTypes.func.isRequired,
    fetchBusiness: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    rootEmpty: PropTypes.string.isRequired,
  }).isRequired,
};

Notifications.defaultProps = {
  business: {},
  count: null,
  filterCount: null,
  expanded: false,
};

const mapStateToProps = store => {
  const filterFormValues = getFormValues('notificationsFilter')(store);
  const filters = {
    ...filterFormValues
      && filterFormValues['Date of Creation From']
      && !validate.date(filterFormValues['Date of Creation From'])
      && moment(filterFormValues['Date of Creation From'], dateFormat).isValid()
      ? { 'Date From': moment(filterFormValues['Date of Creation From'], dateFormat).format(dateFormat) }
      : {},
    ...filterFormValues
      && filterFormValues['Date of Creation To']
      && !validate.date(filterFormValues['Date of Creation To'])
      && moment(filterFormValues['Date of Creation To'], dateFormat).isValid()
      ? { 'Date To': moment(filterFormValues['Date of Creation To'], dateFormat).format(dateFormat) }
      : {},
    ...filterFormValues
      && filterFormValues['User ID']
      ? { 'User ID': filterFormValues['User ID'] }
      : {},
    ...filterFormValues
      && filterFormValues['Watcher User ID']
      ? { 'Watcher User ID': filterFormValues['Watcher User ID'] }
      : {},
    ...filterFormValues
      && filterFormValues['Patient ID']
      ? { 'Patient ID': filterFormValues['Patient ID'] }
      : {},
    ...filterFormValues
      && filterFormValues['Notification Type']
      ? { 'Notification Type': filterFormValues['Notification Type'] }
      : {},
  };
  const uniqUserNotifications = uniqBy(store.userNotifications.data, 'Notification.ID');
  return {
    userNotifications: store.userNotifications.data,
    count: store.userNotifications.count,
    filterCount: store.userNotifications.filterCount,
    account: store.account,
    loading: store.userNotifications.loading,
    initialized: store.userNotifications.initialized,
    business: store.business.data,
    savedFilters: store.account['Saved Filters'] ? JSON.parse(store.account['Saved Filters']) : null,
    filters,
    filterFormValues,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    initializeUserNotifications,
    fetchUserNotifications,
    fetchBusiness,
    readUserNotifications,
    readAllUserNotifications,
    reset,
    change,
    updateUser,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withWidth()(Notifications)),
);



// WEBPACK FOOTER //
// ./src/components/home/Notifications/Notifications.js